<template>
    <div>
        <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
            <div class="bg-theme-green px-4 py-2 text-white">
                <div class="flex justify-between items-center" :class="(item?.BatchLot)?'pb-10':''">
                    <div v-if="item?.pmdProduct" class="font-bold tracking-wider leading-tight text-2xl mt-0">
                        {{item.pmdProduct.name}}
                    </div>
                    <div v-else class="font-bold tracking-wider leading-tight text-2xl mt-0">
                        Add New Product
                    </div>
                    <span @click="closeAdd" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
                </div>
            </div>
            <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
                <!-- Autofill Manual gtin -->
                <div class="flex gap-3 items-center justify-center xl:flex-row flex-col">
                    <div>
                        <div class="input-wrapper">
                            <label for="item-auto-fill" class="flex justify-center items-center cursor-pointer px-1 py-1">
                                <span class="mr-2 text-white text-base font-bold tracking-wider"> Autofill </span>
                                <input v-model="autoFill" type="checkbox" value="" id="item-auto-fill" class="sr-only peer">
                                <div class="w-12 h-6 bg-theme-green relative rounded-full peer 
                                dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] 
                                after:absolute  after:bg-white after:border-gray-400 after:border after:rounded-full 
                                after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-theme-green"></div>
                                <span class="ml-2 text-white text-base font-bold tracking-wider"> Manual </span>
                            </label>
                        </div>
                    </div>
                </div>

                <div v-if="autoFill?'':'hidden'">
                    <div class="bg-theme-borderblack h-1 w-full my-4"></div>
                    <div class="flex items-center">  
                        <search-select placeholder="Search by GTIN, SKU, or Name" :complianceSetting="complianceSetting" @select="masterProduct" />
                    </div>
                </div>
                <div class="bg-theme-borderblack h-1 w-full my-4"></div>

                <div :class="(autoFill || searchResult.name)?'':'hidden'">
                    <div>
                        <div class="flex items-center">   
                            <div class="w-full flex justify-between">
                                <div class="input-wrapper flex items-center">
                                    <span class="product-num text-base font-bold">1</span>
                                    <h2 class=" text-base font-bold tracking-wider ml-2">Product Information</h2>
                                </div>
                                <a v-if="productValidated" @click.prevent="editProductInfo" href="#" class="text-theme-green text-sm font-medium tracking-widest">EDIT</a>
                            </div>
                        </div>
                        <div :class="current=='product'?'':'hidden'">
                            <product-info :defaults="searchResult" @validated="productEmitted" />
                        </div>
                    </div>

                    <div class="bg-theme-borderblack h-1 w-full my-4"></div>
                    <div class="flex items-center">   
                        <div class="w-full flex justify-between">
                            <div class="input-wrapper flex items-center">
                                <span class="product-num text-base font-bold">2</span>
                                <h2 class=" text-base font-bold tracking-wider ml-2">Variant &amp; Stock Information</h2>
                            </div>
                            <a v-if="variantValidated" @click.prevent="editVariantInfo" href="#" class="text-theme-green text-sm font-medium tracking-widest">EDIT</a>
                        </div>
                    </div>
                    <div :class="current=='variant'?'':'hidden'">
                        <variant-info :defaults="searchResult" :productForm="productForm" @validated="variantEmitted" />
                    </div>
                    <div class="bg-theme-borderblack h-1 w-full my-4"></div>
                    <div class="flex items-center">   
                        <div class="w-full flex justify-between">
                            <div class="input-wrapper flex items-center">
                                <span class="product-num text-base font-bold">3</span>
                                <h2 class=" text-base font-bold tracking-wider ml-2">Lot Information</h2>
                            </div>
                        </div>
                    </div>
                    <div :class="current=='lot'?'':'hidden'">
                        <lot-info :asn="asn" :defaults="searchResult" :productForm="productForm" :variantForm="variantForm" @validated="lotEmitted" />
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
import { ref, defineComponent } from 'vue'
import {mapGetters, mapMutations} from 'vuex'
import SearchSelect from './searchSelect'
import BusinessSearchSelect from './businessSearchSelect'
import ProductInfo from '@/views/Products/Product/Add/ProductInfo'
import VariantInfo from '@/views/Products/Product/Add/VariantInfo'
import LotInfo from '@/views/Products/Product/Add/LotInfo'
import ProductApi from '@/controllers/BusinessProductApis'
import { useSnackbar } from "vue3-snackbar"
import Helpers from '@/helpers'
import ObjectHelper from '@/helpers/object'
import ProductHelper from '@/helpers/product'
import LocationComplianceApis from '@/controllers/LocationComplianceApis';

export default defineComponent({
    props: ['item', 'fulfillment', 'asn'],
    components: {
        BusinessSearchSelect,
        SearchSelect,
        ProductInfo,
        VariantInfo,
        LotInfo
    },
    setup() {
        const snackbar = useSnackbar();
        const autoFill = ref(true)
        const searchResult = ref({})
        const current = ref('')  // product, variant, lot
        const mergeProduct = ref({})
        const productForm = ref({})
        const productValidated = ref(false)
        const variantForm = ref({})
        const variantValidated = ref(false)
        const lotForm = ref({})
        const productCreated = ref({})
        const productTemplate = {
            name: '',
            brandId: '',
            categoryId: '',
            tax: '',
            strain: '',
            complianceType: '',
            sku: '',
            concentration_unit: '',
            description: '',
            variantName: '',
            dryCannabisEquivalency: '',
            thc_cbd_value_type: 'single',
            cost: '',
            sale_price: '',
            price: '',
            barcode: '',
            thc: '',
            thc_min: '',
            thc_max:'',
            cbd: '',
            cbd_min: '',
            cbd_max:'',
            badge_running: true,
            batch_lot: '',
            packaged_on: '',
            current_nou: '',
            lot_cost: '',
            caseSize: '',
            licensedProducer: ''
        }
        const complianceSetting = ref({})

        return {
            snackbar, autoFill, searchResult, current, mergeProduct,
            productForm, productValidated, variantForm, variantValidated, lotForm,
            productCreated, productTemplate, complianceSetting
        }
    },
    mounted(){
        this.resetDefault()
        this.getComplianceSetting()
    },
    computed: {
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected'
        })
    },
    methods: {
        async getComplianceSetting(){
            let res = await LocationComplianceApis.fetch();
            if(res.status == 200){
                this.complianceSetting = res.data.payload

            }
        },
        masterProduct(result){
            this.searchResult = ObjectHelper.pickWithDefault(
                result, 
                ['name','strain','complianceType','current_nou','sku','concentration_unit','description','longDescription','thc_cbd_value_type','thc','thc_min','thc_max','cbd','cbd_min','cbd_max','cost','sale_price','batch_lot','packaged_on','lot_cost', 'totalTerp','caseSize'],
                ['', '', '', null, '', '', '', '', 'single', null, null, null, null, null, null, null, null, null, null, null, '', null]
            )
            this.searchResult.categoryId = result.categoryId
            this.searchResult.brandId = result.brand_id
            this.searchResult.brandName = this.item.Brand
            this.searchResult.tax = ''
            this.searchResult.barcode = result.gtin
            this.searchResult.variantName = result.size
            this.searchResult.dryCannabisEquivalency = result.weight_equivalent_dry_cannabis
            if(result?.producer?.licensedProducer){
                this.searchResult.licensedProducer = result.producer.licensedProducer
            }
            
            // for asn file
            if(result.image) this.searchResult.image = result.image
            if(result.aroma) this.searchResult.aroma = result.aroma
            if(result.terpene) this.searchResult.terpene = result.terpene
        },
        closeAdd(){
            this.$emit('close')
        },
        editProductInfo(){
            this.current = 'product'
        },
        productEmitted(form){
            this.current = 'variant'
            this.productValidated = true
            this.productForm = form
        },
        editVariantInfo(){
            this.current = 'variant'
        },
        variantEmitted(form){
            this.variantValidated = true
            this.variantForm = form
            this.current = 'lot'
            if(!this.vg_selectedLocation.id){
                this.createProduct()
            }
        },
        lotEmitted(form){
            this.lotForm = form
            this.createProduct()
        },
        async createProduct(){
            let productData
            let cannabisProfileData = ProductHelper.getDataForCannabisProfileApi({locationId: this.vg_selectedLocation.id, product: this.productForm, variant: this.variantForm, lot: this.lotForm, fulfillment: this.fulfillment})
            let productPricingData = ProductHelper.getDataForProductPricingApi({locationId: this.vg_selectedLocation.id, variant: this.variantForm})
            let batchData = ProductHelper.getDataForBatchApi({locationId: this.vg_selectedLocation.id, lot: this.lotForm})
            if(this.asn){
                productData = ProductHelper.getDataForPoApi({locationId: this.vg_selectedLocation.id, product: this.productForm, variant: this.variantForm, lot: this.lotForm})
                this.asnSaveProduct(productData, cannabisProfileData, productPricingData, batchData)
            }else{
                productData = ProductHelper.getDataForProductApi({businessId: this.vg_selectedBusiness.id, product: this.productForm, variant: this.variantForm, lot: this.lotForm})
                this.saveProduct(productData, cannabisProfileData, productPricingData, batchData)
            }
        },

        async asnSaveProduct(productData, cannabisProfileData, productPricingData, batchData){
            this.vm_spinner(true)
            let obj = {
                product: productData,
                mediaTerpen: null,
                cannabisProfile: cannabisProfileData,
                pricing: productPricingData,
                batch: batchData,
                purchaseOrderId: this.asn.id
            }
            let res = await ProductApi.addOrUpdatePurchaseOrderItem(obj)
            if(res.status===201){
                // add and remove taxes
                let variantIds = [res.data.payload.product.id]
                await this.addOrRemoveProductTax(variantIds, [], this.productForm.tax)

                // add featured category
                if(this.productForm.featuredCategoryIds && this.productForm.featuredCategoryIds.length>0){
                    let featuredData = {
                        locationId: this.vg_selectedLocation.id,
                        categoryIds: this.productForm.featuredCategoryIds
                    }
                    await ProductApi.setFeaturedCategory(res.data.payload.product.id, featuredData)
                }
            }
            if(res.status==201){
                this.emitter.emit("reloadAddAsnList")
                this.emitter.emit('closeAddEditInPurchaseOrder')
            }
            this.snackbar.add({
                type: 'info',
                text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            this.vm_spinner(false)
        },
        async saveProduct(productData, cannabisProfileData, productPricingData, batchData){
            this.vm_spinner(true)
            // create product
            let res = await ProductApi.createProduct(productData)
            let success = true
            let msg = ''
            if(res.data && res.data.payload && res.data.payload.id){
                this.productCreated = res.data.payload
                // add tax to product
                await ProductApi.addBulkProductTax({locationId: this.vg_selectedLocation.id, productId: res.data.payload.id, taxIds: this.productForm.tax})
                msg = 'Product created, '

                if(this.vg_selectedLocation.id){
                    // create cannabis profile
                    let profileRes = await ProductApi.createCannabisProfile(this.productCreated.id, cannabisProfileData)
                    if(profileRes.status=='200'){
                        msg += 'Cannabis profile created, '
                    }else{
                        msg += 'Cannabis profile not created, '
                        success = false
                    }
                
                    // create product pricing
                    productPricingData.productId = res.data.payload.id
                    let pricingRes = await ProductApi.createProductPricing(productPricingData)
                    if(pricingRes.status=='201'){
                        msg += 'Pricing created, '
                    }else{
                        msg += 'Pricing not created, '
                        success = false
                    }

                    // create batch
                    batchData.productId = res.data.payload.id
                    let batchRes = await ProductApi.createProductBatch(batchData)
                    if(batchRes.status=='201'){
                        msg += 'Batch created, '
                    }else{
                        msg += 'Batch not created, '
                        success = false
                    }

                    // add featured category
                    if(productData.featuredCategoryIds?.length>0){
                        let featuredData = {
                            locationId: this.vg_selectedLocation.id,
                            categoryIds: productData.featuredCategoryIds
                        }
                        await ProductApi.setFeaturedCategory(this.productCreated.id, featuredData)
                    }

                    // asn bulk upload - add image
                    if(this.searchResult.image){
                        let productImageData = {
                            productId: this.productCreated.id,
                            url: this.searchResult.image,
                            default: true,
                            sort: 1,
                        }
                        await ProductApi.createProductImage(productImageData)
                    }

                    // asn bulk upload - add terpene & aroma
                    let aromaTerpenePromises = []
                    let self = this
                    if(this.searchResult?.aroma?.length>0){
                        this.searchResult.aroma.forEach(function(each){
                            aromaTerpenePromises.push(ProductApi.addAromas(self.productCreated.id, {aromaId: each.id}))
                        })
                    }
                    if(this.searchResult?.terpene?.length>0){
                        this.searchResult.terpene.forEach(function(each){
                            aromaTerpenePromises.push(ProductApi.addTerpene(self.productCreated.id, {terpeneId: each.id}))
                        })
                    }
                    await Promise.all(aromaTerpenePromises)

                }
                this.resetDefault()
                this.vm_spinner(false)
                this.snackbar.add({
                    type: 'info',
                    text: success ? "New product created successfully." : msg,
                    duration: 3000,
                })
                this.$emit('added', this.item)
            }else{
                this.vm_spinner(false)
                if(res.response?.data?.message){
                    this.snackbar.add({
                        type: 'info',
                        text: res.response.data.message,
                        duration: 3000,
                    })
                }
            }
        },
        async addOrRemoveProductTax(productIds, productTax, formTax){
            // add tax
            let preUpdatedTaxes = productTax.map(each => {return each.id})
            let removed = _.difference(preUpdatedTaxes, formTax)
            let added = _.difference(formTax, preUpdatedTaxes)

            for(let i=0; i<removed.length; i++){
                await ProductApi.removeProductTax({locationId: this.vg_selectedLocation.id, productIds: productIds, taxId: removed[i]})
            }

            for(let j=0; j<added.length; j++){
                await ProductApi.addProductTax({locationId: this.vg_selectedLocation.id, productIds: productIds, taxId: added[j]})
            }
        },
        resetDefault(){
            this.search = ''
            this.productValidated = false
            this.variantValidated = false
            this.current = 'product'
            this.searchResult = {...this.productTemplate}
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>
